<template>

    <div class="filter-calendar-nav">
        <div
            class="nav prev touch-manipulation"
            :class="{ 'disabled': isOnFirstSlide() }"
            type="button"
            aria-label="prev"
            title="prev"
            role="button"
            tabindex="0"
            @click="prevSlide()"
        ></div>
        <div class="flex flex-grow justify-center">
            <div
                class="nav year touch-manipulation"
                :class="{ 'active': Number(year) === Number(activeYear) }"
                type="button"
                :aria-label="year"
                :title="year"
                role="button"
                tabindex="0"
                v-for="year in years"
                v-html="year"
                @click="slideToYear(year)"
            ></div>
        </div>
        <div
            class="nav next touch-manipulation"
            :class="{ 'disabled': isOnLastSlide() }"
            type="button"
            aria-label="next"
            title="next"
            role="button"
            tabindex="0"
            @click="nextSlide()"
        ></div>
    </div>

    <swiper
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        ref="swiperCalendar"
        :slides-per-view="1"
        :space-between="0"
        :threshold="20"
        :loop="false"
        :breakpoints="options.breakpoints || {
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
        }"
        class="filter-calendar"
        :class="{
            'faded' : selected.start.dateClean
        }"
        :data-filter-reference="filters.reference"
        :data-selected-value="selected.start.dateClean"
    >
        <div
            v-if="this.for === 'detail' && isLoading() && ! hasFullyLoaded()"
            class="flex items-center justify-center absolute left-0 top-0 w-full h-full z-10 bg-hh-cyan-100/50"
        >
            <div class="size-24 logo-loader"></div>
        </div>

        <template v-for="(yearData, year) in this.calendarData">

            <swiper-slide
                class="month"
                :class="{ 'loading' : isLoading() }" v-for="(monthData, monthHeading) in yearData"
                :data-year-ref="year"
            >
                <div class="py-10 pb-8 xl:pb-10">

                <div class="month-heading" v-html="monthHeading"></div>

                <div
                    class="absolute flex justify-center left-0 top-0 w-full h-full bg-hh-cyan-100/50"
                    v-show="! isLoading() && ! determineMonthActive(monthHeading) && fullyLoaded"
                >
                    <div
                        class="flex items-center mt-48 h-16 mx-8 px-8 text-center bg-hh-orange-100 shadow-center font-semibold"
                        v-html="translations['no-available-start-dates']"
                    ></div>
                </div>

                <div class="week">
                    <div class="day name" v-for="day in [1,2,3,4,5,6,7]">
                        {{ translations['days-short'][day] }}
                    </div>
                </div>

                <div class="week" v-for="(weekData) in monthData">
                    <div
                        :data-ref="! dayData.isOverflow ? dayData.dateClean : null"
                        class="day touch-manipulation"
                        @click="handleClick(dayData)"
                        @mouseover.prevent="handleDateOver(dayData)"
                        @mouseleave.prevent="handleDateLeave(dayData)"
                        :class="{
                            'overflow' : dayData.isOverflow,
                            'selectable' : isDateSelectable(dayData),
                            'end-date' : isDateSelectableEndDate(dayData),
                            'selected' : isDateSelected(dayData),
                            // 'faded' : isDateSelectableFaded(dayData),
                        }"
                        v-for="(dayData) in weekData"
                        data-no-phone-number
                    >{{ isDateAvailable(dayData) ? dayData.day : '×' }}</div>
                </div>
                </div>

            </swiper-slide>

        </template>
    </swiper>

    <input type="hidden" :data-filter-reference="filtersLos.reference" :data-selected-value="lengthOfStaySegment">

    <div class="active-dates-container z-20" v-if="isStartDateSet()">

        <div class="active-dates">
            <div class="mr-16 font-medium hidden sm:block">{{ translations['arrival-and-stay'] }}</div>
            <div class="flex items-center">
                <span
                    class="active-date"
                    :class="{
                        'text-hh-grey-500' : hoverStartDateFormatted !== null && hoverStartDateFormatted !== this.selected.start.dateFormatted
                    }"
                >{{ activeStartDate }}</span>
                <span v-show="isStartDateSet()">→</span>
                <span
                    v-show="isStartDateSet()"
                    class="active-date"
                    :class="{
                        'text-hh-grey-500' : hoverEndDateFormatted !== null && hoverEndDateFormatted !== this.selected.end.dateFormatted
                    }"
                >
                    {{ activeEndDate }}
                </span>
                <span v-show="isStartDateSet()" class="cursor-pointer hover:opacity-90" @click.prevent="clear()">
                    <img class="w-4 h-4" src="/assets/img/frontend-v3/icons/global/icon-x-grey-700.svg" alt="x">
                </span>
            </div>
        </div>
    </div>

    <div
        class="flexible-dates"
        :data-filter-reference="translations['flexible-dates']['reference']"
        :data-selected-value="flexibleSearchValue"
        v-if="showFlexibleDates"
    >
        <div class="">
            <form-group
                category="toggle"
                :form-data="{
                    'type': '',
                    'label': null,
                    'name': 'flexible_dates',
                    'value': filters.items.useFlexibleDates ? 1 : 0,
                }"
                :data="[
                    {
                        'text': translations['flexible-dates']['yes'],
                        'value': 1,
                    },
                     {
                        'text': translations['flexible-dates']['no'],
                        'value': 0,
                    }
                ]"
                :options="{'noMargin': true, 'emit': true }"
            ></form-group>
        </div>

        <div class="mx-4 leading-6 text-sm">
            {{ translations['flexible-dates']['text-1'] }}<br>
            <span class="text-hh-grey">{{ translations['flexible-dates']['text-2'] }}</span>
        </div>

    </div>

    <div class="text-center bg-hh-orange-100 border-t border-hh-cyan-300" v-if="false">
<!--    {{ selectedTemp }}-->
<!--    {{ filters.reference + ':' + selected.start.dateClean }}-->
<!--    {{ filtersLos.reference + ':' + lengthOfStaySegment }}-->
<!--    {{ 's: ' + selected.start.date }}-->
<!--    {{ 'sc: ' + selected.start.dateClean }}-->
<!--    {{ 'e:' + selected.end.date }}-->
<!--    {{ 'ec:' + selected.end.dateClean }}-->
<!--    {{ 'sh:' + hoverStartDateFormatted }}-->
<!--    {{ 'eh:' + hoverEndDate }}-->
<!--    {{ 'los:' + lengthOfStay }}-->
<!--    {{ 'as:' + Object.values(this.activeDates).length }}-->
<!--    {{ 'ae:' + Object.values(this.activeEndDates).length }}-->
<!--    {{ 'fs:' + (isOnFirstSlide() ? 1 : 0) }}-->
<!--    {{ 'ls:' + (isOnLastSlide() ? 1 : 0) }}-->
<!--    {{ 'am: ' + activeMonthIndex }}-->
<!--    {{ 'ay: ' + activeYear }}-->
<!--    {{ 'fl: ' + (flexibleSearchValue ?? '-') }}-->
<!--    {{ 'y: ' + (years ?? '-') }}-->
    </div>

</template>

<script>

import {Swiper, SwiperSlide} from "swiper/vue";
import HandlesFilters from "../../../Mixins/HandlesFilters.js";

export default {

    name: "ArrivalAndStay",

    components: {SwiperSlide, Swiper},

    mixins: [HandlesFilters],

    props: ['filter-data', 'filter-data-los', 'options', 'for'],

    data() {
        return {

            mode: this.for ?? 'overview',//detail, booking(?)
            hasInitialized: false,
            isActive: false,

            filters: {},
            filtersLos: {},
            calendarData: {},
            activeMonths: [],
            activeDates: {},
            activeEndDates: {},
            availableDates: {},
            years: {},
            activeYear: null,
            selectedTemp: [],

            selected: {
                start: {
                    date: null,
                    dateClean: null,
                    dateFormatted: null,
                },
                end: {
                    date: null,
                    dateClean: null,
                    dateFormatted: null,
                },
            },

            allowHover:true,
            hoverEndDate:null,
            hoverEndDateClean:null,
            hoverEndDateFormatted:null,

            hoverStartDateFormatted:null,

            selectedLos: null,

            urlPrefix: null,
            urlPrefixEndDates: null,
            // urlSegments: null,
            translations: {},

            loadingEvents: [],
            showLoader: true,

            showFlexibleDates: true,
            flexibleSearchValue: null,

            observer: null,
            limitMonths: false,
            limitMonthsAddition: '',//'?initial',
            fullyLoaded: false,
        }
    },

    created() {
        this.filters = this.filterData;
        this.filtersLos = this.filterDataLos;
        this.calendarData = this.filterData.items.calendarDataInit;

        let options = this.options;

        if (this.isJsonString(options)) {
            options = this.options ? JSON.parse(this.options) : {};
        }

        //lol
        this.showFlexibleDates = options.showFlexibleDates ?? this.showFlexibleDates;
        this.flexibleSearchValue = this.filters?.items?.flexibleSearchValue ?? this.flexibleSearchValue;
        this.isActive = options.isActive ?? this.isActive;

        this.initData();
        this.initSelected();
        this.addLoadingEvent('init');
    },

    mounted() {

        // this.Bus.on('filter-segments-changed', (segments) => {
        //     this.urlSegments = segments;
        // });

        this.Bus.on('start-loading', (reference) => {
            if (reference === 'calendar-start-dates' || reference === 'calendar-end-dates') {
                this.addLoadingEvent(reference);
            }
        });

        this.Bus.on('stop-loading', (reference) => {
            this.showLoader = true;
            if (reference === 'calendar-start-dates' || reference === 'calendar-end-dates') {
                this.removeLoadingEvent(reference);
            }
        });

        //flexible search on toggle change
        if (this.filters.items.useFlexibleDates) {
            this.enableFlexibleDates();
        }

        this.Bus.on('form-toggle-changed', (data) => {

            if (data.name === 'flexible_dates') {

                if (data.value === 1) {
                     this.enableFlexibleDates();
                } else {
                    this.disableFlexibleDates();
                }

                this.updateFlexibleDates();
            }
        });

        this.Bus.on('disable-flexible-dates', () => {
            this.disableFlexibleDates();
            this.updateFlexibleDates();
        });

        this.Bus.on('clear-primary-filter', (reference) => {
            if (reference === 'arrival') {
                this.clearAndReload();
            }
        });

        this.Bus.on('clear-filter', (data) => {

            if (data.reference === 'arrival' || data.baseCategory === 'arrival-day') {
                this.clearSelected();

                this.Bus.emit('calendar-change', {
                    startDate: this.selected.start ?? null,
                    lengthOfStay: this.lengthOfStay ?? null,
                });
            }

            if (data.reference === 'exact') {
                this.flexibleSearchValue = null;
            }
        });

        this.Bus.on('activate-filter', (reference) => {
            if (reference === 'arrival' && ! this.isActive) {
                this.activateAndInit();
            }
        });

        this.Bus.on('popup-handle-apply', (reference) => {
            if (reference === 'arrival') {
                this.Bus.emit('close-popup', 'arrival');
            }
        });

        this.Bus.on('popup-handle-clear', (reference) => {
            if (reference === 'arrival') {

                this.Bus.emit('calendar-change', {
                    startDate: null,
                    lengthOfStay: null,
                });

                this.clearAndReload();
            }
        });

        this.Bus.on('filter-change', () => {
            this.isActive = false;
        });

        this.Bus.on('grid-calendar-change', (data) => {

            //clear if deselected in grid calendar
            if (data.dateStart === null) {

                this.clearSelected();

                this.Bus.emit('calendar-change', {
                    startDate: this.selected.start ?? null,
                    lengthOfStay: this.lengthOfStay ?? null,
                });

                return;
            }

            this.selected.start.date = data.dateStart['Y-m-d'];
            this.selected.start.dateClean = data.dateStart['Ymd'];
            this.selected.start.dateFormatted = data.dateStart['d-m-Y'];

            this.selected.end.date = null;
            this.selected.end.dateClean = null;
            this.selected.end.dateFormatted = null;

            this.activeYear = new Date(this.selected.start.date).getFullYear();

            this.$nextTick(() => {
                this.buildAll();

                this.$nextTick(() => {

                    this.loadActiveEndDates();

                    this.$nextTick(() => {

                        this.selected.end.date = data.dateEnd['Y-m-d'];
                        this.selected.end.dateClean = data.dateEnd['Ymd'];
                        this.selected.end.dateFormatted = data.dateEnd['d-m-Y'];

                        this.slideToActiveMonth(0);

                        this.Bus.emit('calendar-change', {
                            startDate: this.selected.start ?? null,
                            lengthOfStay: this.lengthOfStay ?? null,
                        });
                    });
                });
            });
        });

        this.removeLoadingEvent('init');

        //new loading events start here
        if (this.isActive) {
            // this.init();
        }

        //init calendar when it's in the viewport

        // const el = document.querySelector('section[data-section-reference="availability"]');
        const el = document.querySelector('div.filter-calendar');

        this.observer = new window.IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    // Run when section enters view
                    if (entry.isIntersecting) {
                        this.init();
                        this.observer.disconnect();
                    }
                });
            },
            {
                threshold: 0.1 // Adjust as needed (0.1 = trigger when 10% is in view)
            }
        );

        if (el) {
            this.observer.observe(el);
        }
    },

    watch: {
        filterData: function(newFilters, oldFilters) {
            this.filters = newFilters;
            this.initData();
        },

        filterDataLos: function(newFilters, oldFilters) {
            this.filtersLos = newFilters;
            this.initData();
        },
    },

    methods: {

        activateAndInit() {
            this.isActive = true;
            this.init();
        },

        init() {
            this.calendarData = this.filters.items.calendarData;

            // this.initData();

            if (this.isActive) {
                this.loadActiveStartDates(this.isStartDateSet());
            }
        },

        initData() {
            if (this.options.overrides) {

            }

            this.filterUrl = this.url;
            // console.log('--------------------------- initData');
            // console.log('this.filters');
            // console.log(this.filters);
            // console.log('this.filtersLos');
            // console.log(this.filtersLos);
            // console.log('initData this.calendarData');
            // console.log(this.calendarData);

            this.initYears();

            this.activeYear = this.activeYear === null ? this.years[0] : this.activeYear;

            this.translations = this.filters.translations;
            this.urlPrefix = this.options.overrides?.filters?.items?.urlPrefix ?? this.filters.items.urlPrefix;
            this.urlPrefixEndDates =  this.options.overrides?.filters?.items?.urlPrefixEndDates ?? this.filters.items.urlPrefixEndDates;
            this.urlSegments = this.filters.items.urlSegments;
        },

        initSelected() {
            //selected
            this.selected.start = {};
            this.selected.end = {};

            if (this.filters.items.selectedDates.start) {

                this.selected.start = this.filters.items.selectedDates.start;

                this.activeYear = new Date(this.selected.start.date).getFullYear();

                if (this.filters.items.selectedDates.end) {
                    this.selected.end = this.filters.items.selectedDates.end;
                }

                this.$nextTick(() => {
                    this.slideToActiveMonth(0);
                });
            }

            if (this.for === 'detail' && ! this.isStartDateSet()) {
                // this.limitMonths = true;
            }
        },

        initYears() {
            this.years = Object.keys(this.calendarData).filter(year => Object.keys(this.calendarData[year]).length > 0);
        },

        handleClick(dayData) {

            if (dayData.isOverflow || ! this.isDateSelectable(dayData)) {
                return;
            }

            this.allowHover = false;
            let loadData = true;

            //start date (or start and end date) selected and the clicked date matches, clear all
            if (this.selected.start.dateClean === dayData.dateClean) {
                this.clearSelected();
            }
            //end date selected, now deselected if the clicked day matches
            else if (this.selected.end.dateClean === dayData.dateClean) {
                this.clearEndDate();
                loadData = false;
            }
            //nothing or just the start date is selected
            else {

                //nothing selected, set start date
                if (this.selected.start.dateClean === null || typeof this.selected.start.dateClean === 'undefined') {

                    this.selected.start.date = dayData.date;
                    this.selected.start.dateClean = dayData.dateClean;
                    this.selected.start.dateFormatted = dayData.dateFormatted;

                    this.$nextTick(() => {
                        this.slideToActiveMonth();
                    });

                } else {

                    //start date is selected and end date is valid, select end date
                    if (this.isDateSelectableEndDate(dayData)) {
                        this.selected.end.date = dayData.date;
                        this.selected.end.dateClean = dayData.dateClean;
                        this.selected.end.dateFormatted = dayData.dateFormatted;
                    }
                    //start date is selected, now a different start date is selected
                    else if (this.isDateSelectableStartDate(dayData)) {
                        this.clearSelected();
                        this.selected.start.date = dayData.date;
                        this.selected.start.dateClean = dayData.dateClean;
                        this.selected.start.dateFormatted = dayData.dateFormatted;

                        this.$nextTick(() => {
                            this.slideToActiveMonth();
                        });
                    }
                }
            }

            // console.log('-------------------------------------------------------------------------------------------> loadData:');
            // console.log(loadData);

            if (this.mode === 'detail' || this.mode === 'booking') {
                this.Bus.emit('calendar-change', {
                    startDate: this.selected.start ?? null,
                    lengthOfStay: this.lengthOfStay ?? null,
                });

            }

            if (loadData) {

                this.$nextTick(() => {

                    this.buildAll();

                    // console.log('=========================================');
                    // console.log(this.urlSegments);
                    // console.log(this.url);

                    if (this.mode === 'detail' || this.mode === 'booking') {
                        // this.Bus.emit('calendar-change', {
                        //     startDate: this.selected.start ?? null,
                        //     lengthOfStay: this.lengthOfStay ?? null,
                        // });
                    } else {
                        this.Bus.emit('filter-change');
                    }

                    if (this.isStartDateSet() && ! this.isEndDateSet()) {
                        this.loadActiveEndDates();
                    }
                    else if (! this.isEndDateSet())  {
                        this.loadActiveStartDates();
                    }
                })
            }
        },

        clear() {
            if (this.mode === 'detail' || this.mode === 'booking') {
                this.emit('clear-filter', {reference: 'arrival'});
            } else {
                this.emit('clear-primary-filter', 'arrival');
            }
        },

        clearAndReload() {
            this.clearSelected();

            this.$nextTick(() => {
                this.Bus.emit('filter-change');

                this.loadActiveStartDates();
            })

        },

        clearSelected() {
            this.clearStartDate();
            this.clearEndDate();
            this.hoverEndDate = null;
            this.hoverEndDateClean = null;
            this.hoverEndDateFormatted = null;
            this.selectedTemp = [];
        },

        clearStartDate() {
            this.selected.start.date = null;
            this.selected.start.dateClean = null;
            this.selected.start.dateFormatted = null;
            this.activeEndDates = {};

            this.handleBetweenDates();
        },

        clearHoverDate() {
            this.hoverEndDate = null;
            this.hoverEndDateClean = null;
            this.hoverEndDateFormatted = null;
        },

        clearEndDate() {
            this.selected.end.date = null;
            this.selected.end.dateClean = null;
            this.selected.end.dateFormatted = null;

            this.clearHoverDate();
            this.handleBetweenDates();
        },

        isStartDateSet() {
            return this.selected.start.date !== null && this.selected.start.date !== undefined;
        },

        isEndDateSet() {
            return this.selected.end.date !== null && this.selected.end.date !== undefined;
        },

        isDateAvailable(dayData) {

            if (this.availableDates && this.availableDates.length > 0) {
                return this.availableDates.includes(dayData.date);
            }

            return true;
        },

        isDateSelectable(dayData) {

            if (dayData.isOverflow) {
                return false;
            }

            return this.activeDates[dayData.date] || Object.values(this.activeEndDates).includes(dayData.date);
        },

        isDateSelectableStartDate(dayData) {

            if (dayData.isOverflow) {
                return false;
            }

            return this.activeDates[dayData.date];
        },

        isDateSelectableEndDate(dayData) {

            if (
                dayData.isOverflow
                || dayData.dateClean === this.selected.start.dateClean
            ) {
                return false;
            }

            return Object.values(this.activeEndDates).includes(dayData.date);
        },

        isDateSelectableFaded(dayData) {

            if (
                this.isDateSelectableEndDate(dayData)
                || this.isDateSelected(dayData)
                || this.isWithinEndDateRange(dayData)
                || Object.values(this.activeEndDates).length === 0
            ) {
                return false;
            }

            return this.isDateSelectable(dayData);
        },

        isDateSelected(dayData) {
            return ! dayData.isOverflow
                && (
                    this.selected.start.dateClean === dayData.dateClean
                    || (this.selected.end.dateClean === dayData.dateClean) && this.hoverEndDate === null)
                ;
        },

        handleDateOver(dayData) {

            if (! this.allowHover) {
                return;
            }

            if (this.selected.start.date === null) {
                return;
            }

            if (this.selected.start.date !== dayData.date && ! this.isWithinEndDateRange(dayData) && this.isDateSelectable(dayData)) {
                this.hoverStartDateFormatted = dayData.dateFormatted;
            }

            if (! this.isWithinEndDateRange(dayData)) {
                return;
            }

            if (this.isDateSelectableEndDate(dayData)) {
                this.hoverEndDate = dayData.date;
                this.hoverEndDateClean = dayData.dateClean;
                this.hoverEndDateFormatted = dayData.dateFormatted;
            }

            this.handleBetweenDates();
        },

        handleDateLeave(dayData) {

            this.allowHover = true;

            this.hoverStartDateFormatted = null;

            if (! this.isWithinEndDateRange(dayData)) {
                return;
            }

            this.clearHoverDate();
            this.handleBetweenDates();
        },

        handleBetweenDates() {

            this.buildSelectedDates();

            this.$nextTick(() => {
                this.markDatesBetween();
            })
        },

        markDatesBetween() {

            // Removing the class from all selected elements
            document.querySelectorAll('.between').forEach(element => {
                element.classList.remove('between');
            });

            this.selectedTemp.forEach(item => {
                let cleanDate = item.replaceAll('-', '');
                let element = document.querySelector('[data-ref="' + cleanDate + '"]');
                element.classList.add('between')
            });
        },

        isWithinEndDateRange(day) {

            if (day.isOverflow) {
                return false;
            }

            if (Object.keys(this.activeEndDates).length === 0) {
                return false;
            }

            let startDate = this.activeEndDates[0];
            let endDate = this.activeEndDates.slice(-1)[0];

            return !! (day.date
                && day.date.replace(/-/g, '') >= startDate.replace(/-/g, '')
                && day.date.replace(/-/g, '') <= endDate.replace(/-/g, ''));
        },

        buildSelectedDates() {

            let targetSelectedEndDate = this.hoverEndDate ?? this.selected.end.date;

            let dateRange = [];
            let push = false;
            let breakLoop = false;
            let targetStartDate = this.selected.start.date;

            //single date click/hover
            if (targetStartDate && ! targetSelectedEndDate && ! this.hoverEndDate) {
                dateRange = [targetStartDate]
            }
            //date range click or end date hover
            else if (targetStartDate && targetSelectedEndDate) {
                for (const [yearString, year] of Object.entries(this.calendarData)) {
                    for (const [monthString, month] of Object.entries(year)) {
                        for (const [weekIndex, week] of Object.entries(month)) {
                            for (const [index, day] of Object.entries(week)) {

                                let initBreak = false;
                                let date = day.date;

                                //start the push here
                                if (date === targetStartDate && ! day.isOverflow) {
                                    push = true;
                                }

                                if (push && ! this.isWithinEndDateRange(day) && ! day.isOverflow) {
                                    initBreak = true;
                                    push = false;
                                }

                                if (
                                    ! day.isOverflow
                                    && (
                                        this.hoverEndDate && date === this.hoverEndDate
                                        || ! this.hoverEndDate && date === this.selected.end.date
                                    )
                                ) {
                                    push = false;
                                }

                                if (
                                    push
                                    && ! day.isOverflow
                                    && date !== targetStartDate
                                ) {
                                    dateRange.push(date);
                                }

                                if (date === targetSelectedEndDate && ! day.isOverflow) {
                                    initBreak = true;
                                }

                                if (dateRange.length === 22) {
                                    initBreak = true;
                                }

                                if (initBreak) {
                                    push = false;
                                    breakLoop = true;
                                    break;
                                }
                            }

                            if (breakLoop === true) {
                                break;
                            }
                        }

                        if (breakLoop === true) {
                            break;
                        }
                    }

                    if (breakLoop === true) {
                        break;
                    }
                }
            }

            if (! this.isWithinEndDateRange({ date: targetSelectedEndDate })) {
                dateRange = [];
            }

            this.selectedTemp = dateRange;

            // console.log('this.selectedTemp:');
            // console.log(this.selectedTemp);
        },

        loadActiveStartDates(loadEndDates = false) {

            this.buildAll();

            if (this.showLoader) {
                this.Bus.emit('start-loading', 'calendar-start-dates');
            }

            // console.log('zzzzzzzzzzzzzzz this.activeDatesUrl: ');
            // console.log(this.urlSegments);
            // console.log(this.activeDatesUrl);

            axios.get(this.activeDatesUrl)
                .then(response => {
                    if (response.data) {

                        const trueDates = {};
                        Object.values(response.data.dates).forEach(date => trueDates[date] = true);
                        this.activeDates = trueDates;
                        this.availableDates = response.data.availableDates;
                        this.activeMonths = response.data.activeMonths;

                        // console.log('--------------------------------------------->');
                        // console.log('--------------------------------------------->');
                        // console.log('--------------------------------------------->');
                        // console.log('--------------------------------------------->');
                        // console.log('this.availableDates');
                        // console.log(this.availableDates);
                        // console.log(this.activeMonths);

                        this.Bus.emit('stop-loading', 'calendar-start-dates');

                        this.$nextTick(() => {
                            this.initYears();
                            this.handleBetweenDates();

                            if (! this.hasInitialized){
                                this.slideToFirstSelectableMonth(0);
                                this.hasInitialized = true;
                            }

                            this.fullyLoaded = true;
                        })
                    }

                    if (loadEndDates) {
                        // console.log('loadEndDates seg: ' + this.urlSegments);
                        this.loadActiveEndDates()
                    }
                })
                .catch(error => {
                });
        },

        loadActiveEndDates() {

            this.Bus.emit('start-loading', 'calendar-end-dates');

            this.buildSegments();

            axios.get(this.activeEndDatesUrl)
                .then(response => {
                    if (response.data) {
                        this.activeEndDates = response.data.dates;
                        // this.activeMonths = response.data.activeMonths;

                        this.Bus.emit('stop-loading', 'calendar-end-dates');

                        // this.monthHasSelectableEndDate();

                        this.handleBetweenDates();
                        this.initYears();
                    }
                })
                .catch(error => {
                });
        },

        onSwiper(swiper) {
            this.swiper = swiper;
        },

        onSlideChange(swiper) {
            // this.fullyLoaded = false;
            //
            // if (this.limitMonths && this.limitMonthsAddition !== '') {
            //     this.limitMonths = false;
            //     this.showLoader = false;
            //
            //     this.loadActiveStartDates();
            //     // this.addLoadingEvent('calendar-start-dates');
            // }
        },

        hasFullyLoaded() {
            return true;

            if ((this.limitMonths && this.limitMonthsAddition !== '')) {
                return false;
            }

            return true;
        },

        isOnFirstSlide() {
            return this.isLoading() ? false : (this.swiper?.isBeginning ?? false);
        },

        isOnLastSlide() {
            return this.isLoading() ? false : (this.swiper?.isEnd ?? false);
        },

        nextSlide() {
            this.swiper.slideNext();
            this.handleSlide();
        },

        prevSlide() {
            this.swiper.slidePrev();
            this.handleSlide();
        },

        handleSlide() {
            const nthMonthDiv = document.querySelector(`.filter-calendar .month:nth-child(${(this.swiper?.activeIndex ?? 0)})`);

            if (nthMonthDiv) {
                this.activeYear = nthMonthDiv.dataset.yearRef;
            }
        },

        slideToYear(yearToMatch) {
            const divs = document.querySelectorAll(`div[data-year-ref]`);
            const index = yearToMatch === this.years[0] ? 0 : (Array.from(divs).findIndex(div => div.dataset.yearRef === yearToMatch) + 1);
            this.activeYear = yearToMatch;

            this.swiper.slideTo(index);
        },

        slideToActiveMonth(speed = 500) {
            const day = document.querySelector('.day.selected');

            if (day && this.swiper?.params.slidesPerView > 1) {
                const monthContainingSelectedDay = day.closest('.month');

                if (monthContainingSelectedDay) {
                    const monthIndex = Array.from(monthContainingSelectedDay.parentNode.children).findIndex(child => child === monthContainingSelectedDay);
                    this.swiper.slideTo(monthIndex ?? 0, speed);
                }
            }
        },

        //TODO
        monthHasSelectableEndDate() {
            const selectedDay = document.querySelector('.day.selected');

            if (selectedDay) {

                const monthContainingSelectedDay = selectedDay.closest('.month');

                // Find all days within the same month
                const allDaysInMonth = monthContainingSelectedDay.querySelectorAll('.day');

                // Filter for days with "end-date" and "selectable" classes
                const endDatesSelectable = Array.from(allDaysInMonth).filter(day =>
                    day.classList.contains('end-date') && day.classList.contains('selectable')
                );

                // Count the number of filtered days
                const count = endDatesSelectable.length;
            }
        },

        slideToFirstSelectableMonth(speed = 500) {

            const selectedDay = document.querySelector('.day.selected');

            if (selectedDay) {
                this.slideToActiveMonth();
                return;
            }

            const day = document.querySelector('.day.selectable');

            if (day) {
                const monthContainingSelectedDay = day.closest('.month');

                if (monthContainingSelectedDay) {
                    const monthIndex = Array.from(monthContainingSelectedDay.parentNode.children).findIndex(child => child === monthContainingSelectedDay);
                    this.swiper.slideTo(monthIndex ?? 0, speed);
                }
            }
        },

        isLoading() {
            return this.loadingEvents.length > 0;
        },

        addLoadingEvent(reference) {
            this.loadingEvents.push(reference);
        },

        hasLoadingEvent(reference = null) {

            if (reference === null) {
                return this.loadingEvents.length > 0;
            }

            return this.loadingEvents.includes(reference);
        },

        removeLoadingEvent(reference) {
            this.loadingEvents = this.loadingEvents.filter(item => item !== reference);
        },

        enableFlexibleDates() {
            this.flexibleSearchValue = null;
        },

        disableFlexibleDates() {
            this.flexibleSearchValue = this.translations['flexible-dates']['exact'];
        },

        updateFlexibleDates() {

            if (! this.isStartDateSet()) {
                // No point in taking any actions at the moment. Just make sure the variable is set.
                return;
            }

            if (this.isEndDateSet()) {
                this.$nextTick(() => {
                    this.Bus.emit('filter-change');
                });
            }
        },

        determineMonthActive(title) {

            if (this.hasLoadingEvent()) {
                return true;
            }

            return Object.values(this.activeMonths ?? {}).length > 0 && Object.values(this.activeMonths).includes(title);
        },

        isJsonString(str) {
            try {
                const parsed = JSON.parse(str);
                return typeof parsed === 'object' && parsed !== null && ! Array.isArray(parsed);
            } catch (e) {
                return false;
            }
        }
    },

    computed: {

        activeDatesUrl() {
            let url = this.urlPrefix + (this.urlSegments ? '/' + this.urlSegments : '');

            if (this.limitMonths) {
                url += this.limitMonthsAddition;
            }

            return url;
        },

        activeEndDatesUrl() {
            return this.urlPrefixEndDates + (this.urlSegments ? '/' + this.urlSegments : '');
        },

        lengthOfStay() {
            if (this.selected.start.date && this.selected.end.date) {
                const start = new Date(this.selected.start.date);
                const end = new Date(this.selected.end.date);
                const diffInTime = end.getTime() - start.getTime();
                const diffInDays = diffInTime / (1000 * 3600 * 24);

                return Math.abs(Math.round(diffInDays));
            }

            return null;
        },

        lengthOfStaySegment() {
            if (this.lengthOfStay) {
                let nights = this.translations[this.lengthOfStay !== 1 ? 'nights' : 'night'];

                return this.lengthOfStay + '-' + nights;
            }

            return null;
        },

        activeStartDate() {
            return this.hoverStartDateFormatted ?? this.selected.start.dateFormatted;
        },

        activeEndDate() {

            if (this.selected.start.dateFormatted && this.hoverStartDateFormatted) {
                return '';
            }

            return this.hoverEndDateFormatted ?? this.selected.end.dateFormatted;
        }

    },

    beforeDestroy() {
        // Clean up observer
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
</script>
